module.exports = __webpack_public_path__ + "media/images/social_networks/tiktok-91098f08017a7e88e7fc981559cfabab.svg";